import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import {makeStyles, withStyles} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import {green} from '@material-ui/core/colors';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import {useHistory} from 'react-router-dom';
import jwt_decode from 'jwt-decode';

import CircularProgress from '@material-ui/core/CircularProgress';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getUser, loginUserEndpointCall} from '../api/network/authService';
import {
    businessAccountManagerExistsCall,
    representativeExistCall,
    getCompanyCall,
} from '../api/network/businessCustomerService';
import {roles, saveTokenToLocalStorage} from '../utils/auth';

import {ReactComponent as Logo} from '../assets/SPP.svg';
import {setAuth} from '../redux/actions/AuthActions';
import CustomTextField from '../components/common/CustomTextField';
import FadeTransition from '../components/animations/FadeTransition';
import ErrorMessage from '../components/common/ErrorMessage';
import {saveUser, patchUser} from '../redux/actions/userActions';


const LoginPageLeftSection = styled.div`
    background:  #0C1C45;;  
    display: flex;
    justify-content: center;
    align-items: center;
`;

const LoginPageWrapper = styled.div`
    width: 100vw;
    height: 100vh;
    display: grid;
    grid-template-columns: 1.6fr 1fr;
`;

const LoginPageRightSection = styled.div`
    background: linear-gradient(180deg, #012FA6 0%, #012A95 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const LoginPageLogoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const LogoWrapper = styled.div`
    margin-bottom: var(--space-l1);
`;

const LoginPageFooterWrapper = styled.div`
    position: fixed;
    bottom: 0;
    margin-bottom: var(--space-l1);
    
    font-family: Metropolis,serif;
    font-size: 18px;
    line-height: 18px;    
    text-align: center;
    
    color: var(--white);
`;

const SppNameWrapper = styled.div`
    /* text-4xl/Bold */
    
    font-family: Metropolis,serif;
    font-size: 36px;
    line-height: 36px;
    /* identical to box height, or 100% */
    
    text-align: center;
        color: var(--white);

`;

const SppSloganWrapper = styled.div`
    /* text-xl/Regular */
    
    font-family: Metropolis,serif;
    font-size: 20px;
    line-height: 20px;
    /* identical to box height, or 100% */
    
    text-align: center;
    font-weight: lighter;
    /* default/shade/white */
    color: var(--white);
`;

const LoginCard = styled.div`
    width: 409px;
    height: fit-content; //544px;
    display: flex;
    flex-direction: column;
    align-items: start;
    
    padding: 40px; // 40px 0 40px;
    
    background: #FFFFFF;
    border-radius: 8px;
`;

const SignInCardHeader = styled.div`
    
    /* text-2xl/Bold */
    font-family: Metropolis,serif;
    font-size: 24px;
    font-weight: bold;
    line-height: 24px;
    /* identical to box height, or 100% */
    
   
    /* default/gray/700 */
    color: #4A5568;
`;

const SingInTextFieldsWrapper = styled.div`
   display: flex;
   width: 100%;
   flex-direction: column;
   margin: 8px 0 8px 0
`;

const TextFieldLabelWrapper = styled.div`
    /* text-base/Regular */
    margin: 16px 0 16px 0;
    
    font-family: Metropolis,serif;
    font-weight: lighter;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */
    
    /* default/gray/600 */
    color: #718096;
    
`;

const RememberMeSection = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

const GreenCheckbox = withStyles({
    root: {
        color: green[400],
        '&$checked': {color: green[600], },
    },
    checked: {},
})(props => <Checkbox color="default" {...props} />);

const LoginButton = withStyles({
    root: {margin: '10px 0 10px 0'},
    contained: {
        color: 'var(--white)',
        backgroundColor: 'var(--company)',
        fontFamily: 'Metropolis',
        fontSize: '16px',
    },
    focusVisible: {backgroundColor: 'var(--accent)', }
})(props => <Button variant="contained" {...props} >Login</Button>);

const DontHaveAccountWrapper = styled.div`
    width: 100%;
    text-align: center;
    margin: 10px;
    /* text-xs/Regular */

    font-family: Metropolis,serif;
    font-size: 12px;
    line-height: 12px;
    
    color: #4A5568;
`;

const TermsPrivacyWrapper = styled.div`
    bottom: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 32px;
    color: var(--white);
    //width: 100%;
    
    margin-top: 100px;
`;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        width: '100%',
        margin: '10px 0 20px 0',
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {backgroundColor: green[700], },
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));


function DashboardLogin({saveAuthInfo, patchUser, saveUser}) {
    const classes = useStyles();
    const history = useHistory();

    const [rememberMe, setRememberMe] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});

    const footerMessage = 'Copyright 2020 SMS Smart Payment Plan';
    const slogan = 'Build up to your goals';
    const SPP = 'Smart Payment Plan';

    const [formFields, setFormFields] = useState({username: '', password: ''});

    const handleOnFormFieldChange = e => {
        const {name, value} = e.target;
        setFormFields({
            ...formFields,
            [name]: value
        });

        if (error[name]) {
            delete error[name];
            setError({...error});
        }
    };
    const onChecked = () => {
        setRememberMe(!rememberMe);
    };

    const handleOnLoginClick = async e => {
        if (e) e.preventDefault();
        if (!formIsValid()) return;

        const params = {
            username: formFields.username,
            password: formFields.password
        };

        setLoading(true);

        // call auth service and get user.
        try {
            let authData = await loginUserEndpointCall(params);
            if (authData.token) {
                const tokenData = jwt_decode(authData.token);
                authData = {
                    ...tokenData,
                    ...authData
                };
            }
            // get user id and role
            const {id: userId, role} = authData;

            // based on the role we query the business customer service to determine if the use exist
            let userExist = false;
            let resp;

            const primaryRole = Array.isArray(role) ? role[0] : role;

            switch (primaryRole) {
            case roles.SMS:
            case roles.ADMIN:
            case roles.GK: {
                userExist = true;
                break;
            }
            case roles.COMPANY: {
                // resp = await companyExist(userId);
                const userExist = true;
                break;
            }
            case roles.CUSTOMER_REP: {
                // check to see if customer rep exist in db
                const resp = await representativeExistCall(userId);
                userExist = resp.exists;
                saveUser(resp);
                break;
            }
            case roles.BAM: {
                // check to see if bam exists
                const resp = await businessAccountManagerExistsCall(userId);
                userExist = resp.exists;
                saveUser(resp);
                break;
            }
            default:
                break;
            }

            setLoading(false);
            if (userExist) {
                saveTokenToLocalStorage(authData); // save user to local storage
                saveAuthInfo(authData); // save user to redux store

                // get user info i.e name, email, etc
                const userInfo = await getUser(authData.id, authData.token);
                const {firstName, lastName, email, userName} = userInfo;
                patchUser({firstName, lastName, email, userName});

                // history.push("/");
            } else {
                setError({msg: 'Failed to authorized user. Check details'});
                setLoading(false);
            }
        } catch (e) {
            console.error('User auth failed', e);
            setLoading(false);

            const errorData = e.response && e.response.data;
            if (errorData) {
                console.error('User auth failed', errorData);
                setError({...error, msg: errorData.errors || 'Failed to login, please check credentials.'});
            } else {
                setError({msg: 'Failed to login, please check credentials.'});
            }
        }
    };

    const preventDefault = event => event.preventDefault();

    const formIsValid = () => {
        const error = {};

        Object.keys(formFields).map(key => {
            if (!formFields[key]) {
                error[key] = `${key} is required`;
            }
        });

        setError(error);

        return !(Object.keys(error).length > 0);
    };
    return (
        <LoginPageWrapper>
            <LoginPageLeftSection>

                {/*<FadeTransition>*/}
                <LoginPageLogoWrapper>
                    <LogoWrapper> <Logo/> </LogoWrapper>
                    <SppNameWrapper> {SPP} </SppNameWrapper>
                    <SppSloganWrapper> {slogan} </SppSloganWrapper>
                </LoginPageLogoWrapper>
                {/*</FadeTransition>*/}

                <LoginPageFooterWrapper>
                    {footerMessage}
                </LoginPageFooterWrapper>

            </LoginPageLeftSection>

            <LoginPageRightSection>

                <LoginCard>
                    <SignInCardHeader> Sign In </SignInCardHeader>
                    {error.msg && <ErrorMessage errorMsg={error.msg}/>}

                    <form onSubmit={handleOnLoginClick} noValidate style={{width: '100%'}}>
                        <SingInTextFieldsWrapper>
                            <TextFieldLabelWrapper>
                                username
                            </TextFieldLabelWrapper>
                            <CustomTextField
                                name="username"
                                value={formFields.username}
                                error={error.username !== undefined}
                                type="name"
                                errorMsg={error.username || ''}
                                placeholder="Enter username"
                                onChange={handleOnFormFieldChange}
                            />


                        </SingInTextFieldsWrapper>

                        <SingInTextFieldsWrapper>
                            <TextFieldLabelWrapper>
                                password
                            </TextFieldLabelWrapper>
                            <CustomTextField
                                name="password"
                                value={formFields.password}
                                error={error.password !== undefined}
                                type="password"
                                errorMsg={error.password || ''}
                                placeholder="Enter password"
                                onChange={handleOnFormFieldChange}
                            />
                        </SingInTextFieldsWrapper>


                        <RememberMeSection>
                            <FormControlLabel
                                control={(
                                    <GreenCheckbox
                                        checked={rememberMe}
                                        onChange={onChecked}
                                        value="remember-me"
                                    />
                                )}
                                label="Remember Me"
                            />

                            <Link href="#" onClick={preventDefault} color="inherit">
                                Forgot Password?
                            </Link>

                        </RememberMeSection>

                        <div className={classes.wrapper}>

                            <LoginButton
                                variant="contained"
                                type="submit"
                                size="large"
                                fullWidth
                                disabled={loading}
                                onClick={handleOnLoginClick}
                            > Login </LoginButton>

                            {loading && <CircularProgress size={24} className={classes.buttonProgress}/>}

                        </div>
                    </form>

                    <DontHaveAccountWrapper>Dont have an account?</DontHaveAccountWrapper>

                    <Button
                        variant="outlined"
                        size="large"
                        onClick={() => {
                        }}
                        fullWidth
                    >
                        Create My Account
                    </Button>

                </LoginCard>

                <TermsPrivacyWrapper>
                    <Link href="#" onClick={preventDefault} color="inherit">
                        Terms of Service
                    </Link>

                    <Link href="#" onClick={preventDefault} color="inherit">
                        Privacy Policy
                    </Link>
                </TermsPrivacyWrapper>

            </LoginPageRightSection>
        </LoginPageWrapper>
    );
}

DashboardLogin.propTypes = {};

DashboardLogin.defaultProps = {};
const mapDispatchToProps = {
    saveAuthInfo: setAuth,
    saveUser,
    patchUser,
};

export default connect(null, mapDispatchToProps)(DashboardLogin);
